// src/components/Sidebar.js
import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faFont, faExchangeAlt, faEdit, faTimes } from "@fortawesome/free-solid-svg-icons";
import "./Sidebar.css";

const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(false);

  // Toggle sidebar open/close
  const toggleSidebar = () => {
    setIsOpen(prev => !prev);
  };

  return (
    <>
      { !isOpen && (
        <div className="sidebar-toggle" onClick={toggleSidebar}>
          <FontAwesomeIcon icon={faBars} />
        </div>
      )}
      <aside className={`sidebar ${isOpen ? "open" : ""}`}>
        <div className="sidebar-header">
          <h1>Abishek's Java2Bedrock GUI Converter</h1>
          <button className="sidebar-close" onClick={toggleSidebar}>
            <FontAwesomeIcon icon={faTimes} />
            <span>Close</span>
          </button>
        </div>
        <nav>
          <ul>
            <li>
              <a href="https://abishekbhusal.com/font-converter" onClick={toggleSidebar}>
                <FontAwesomeIcon icon={faFont} />
                <span>Font Converter</span>
              </a>
            </li>
            <li>
              <a href="https://abishekbhusal.com/java2bedrock" onClick={toggleSidebar}>
                <FontAwesomeIcon icon={faExchangeAlt} />
                <span>Normal Converter</span>
              </a>
            </li>
            <li>
              <a href="https://abishekbhusal.com/font-editor" onClick={toggleSidebar}>
                <FontAwesomeIcon icon={faEdit} />
                <span>Font Editor</span>
              </a>
            </li>
          </ul>
        </nav>
      </aside>
    </>
  );
};

export default Sidebar;
